export default {
  'HELP_PAGE_CONTENT': 'Help Center Page',
  'BACK_TO_ALERTS': 'Back to alerts',
  'ALERT_TABLE_HEAD_ALERT': 'Alert',
  'ALERT_TABLE_HEAD_START_TIME': 'Start date & time',
  'ALERT_TABLE_CELL_ALERT': '{event_type} at {intersection_name}',
  'ALERT_TABLE_CELL_START_TIME': '{start_time}',
  'ALERT_TABLE_CELL_OPEN_ON_MAP': 'Open on map',
  'BUSINESS_RULES_ROUTES_TAB': 'Routes',
  'BUSINESS_RULES_PRIORITY_RULES_TAB': 'Priority Rules',
  'BUSINESS_RULES_ROUTES_TABLE_HEAD_LAST_SAVED': 'Last saved',
  'BUSINESS_RULES_ROUTES_TABLE_HEAD_STATUS': 'Status',
  'BUSINESS_RULES_ROUTES_TABLE_CELL_EDIT_RULES': 'Edit rules',
  'BUSINESS_RULES_ROUTES_SEARCH_PLACEHOLDER': 'Search routes',
  'USERS_AND_PERMISSIONS_USERS_TAB': 'Users',
  'USERS_AND_PERMISSIONS_ROLES_TAB': 'Roles',
  'USERS_AND_PERMISSIONS_REQUESTS_TAB': 'Requests',
  'USERS_AND_PERMISSIONS_USERS_TABLE_TITLE': 'Manage or invite users',
  'INVITE_NEW_USER': 'Invite new user',
  'U_AND_P_TABLE_HEADER_EMAIL': 'Email',
  'U_AND_P_TABLE_HEADER_REGISTER_DATE': 'Register Date',
  'U_AND_P_TABLE_HEADER_ROLE': 'Role',
  'U_AND_P_TABLE_HEADER_APPROVED_AGENCIES': 'Approved Agencies',
  'U_AND_P_ADD_AGENCY': 'Add agency',
  'U_AND_P_NO_ADDITIONAL_CHOICES': 'No Additional Choices',
  'MULTI_SELECT_PLACEHOLDER': 'Select items',
  'LOGOUT': 'Logout',
  'SELECT_INTERSECTION': 'Select intersection',
  'BACK_TO_WEBSITE': 'Back to website',
  'PAGE_NOT_FOUND': 'Page not found',
  'PAGE_NOT_FOUND_DESCRIPTION': 'The page you were looking for could not be found',
  'MAP_SEARCH': 'Search for an agency',
  'LIVE_MAP.EVP_SEARCH_PLACEHOLDER': 'Find a vehicle, event, or intersection.',
  'LIVE_MAP.TRANSIT_SEARCH_PLACEHOLDER_LYT21': 'Find a bus or intersection',
  'LIVE_MAP.TRANSIT_SEARCH_PLACEHOLDER': 'Search a bus or intersection',
  'ROUTES_NAV_TSP_STATISTICS': 'TSP Statistics',
  'ROUTES_NAV_PERFORMANCE': 'Performance',
  'SYSTEM_HEALTH_SIGNAL_NETWORK_TAB': 'Signal Network',
  'SYSTEM_HEALTH_TRANSIT_VEHICLE_TAB': 'Transit Vehicle CAD/AVL',
  'SYSTEM_HEALTH_TSP_HEALTH_TAB': 'TSP Health',
  'SYSTEM_HEALTH_ALERTS_TAB': 'Alerts',
  'SYSTEM_HEALTH_METRICS_GROUP': 'Health metrics',
  'SYSTEM_HEALTH_OPERATIONS_GROUP': 'Operational awareness',
  'TEAM_ACTIVE_USERS_TAB': 'Active Users',
  'TEAM_USER_LOGIN_HISTORY_TAB': 'User Login History',
  'TEAM_REQUESTS_TAB': 'Requests',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.TITLE': 'Average TSP Calls Per Hour',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_Y': 'Average TSP Calls per Hour',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_HOUR': 'Hour',
  'TEAM.MODAL.EDIT_ROLE.AGENCY_OWNER_USE_TRANSFER_OWNERSHIP': 'To assign agency ownership, use the Transfer Ownership action on the current Agency Owner row.',
  'TRIP_ANALYZER.PAGE_TITLE': 'Trip Analyzer',
  'TRIP_ANALYZER.QUERY.SERVICE_DATE_LABEL': 'Service date',
  'TRIP_ANALYZER.QUERY.ROUTE_LABEL': 'Route',
  'TRIP_ANALYZER.QUERY.DIRECTION_LABEL': 'Direction',
  'TRIP_ANALYZER.QUERY.TRIP_LABEL': 'Trip',
  'TRIP_ANALYZER.QUERY.PARTNER_LABEL': 'Jurisdiction',
  'TRIP_ANALYZER.QUERY.ALL_PARTNERS_OPTION': 'All jurisdictions',
  'TRIP_ANALYZER.QUERY.SELECT_ROUTE_PLACEHOLDER': 'Select a route',
  'TRIP_ANALYZER.QUERY.SELECT_DIRECTION_PLACEHOLDER': 'Select a direction',
  'TRIP_ANALYZER.QUERY.SELECT_TRIP_PLACEHOLDER': 'Select a trip',
  'TRIP_ANALYZER.QUERY.SELECT_PARTNER_PLACEHOLDER': 'All jurisdictions',
  'TRIP_ANALYZER.TIMELINE.TABLE_CONTROLS_LABEL': 'Table controls',
  'TRIP_ANALYZER.TIMELINE.TABLE_LEGEND_LABEL': 'Table legend',
  'TRIP_ANALYZER.TIMELINE.TABLE_VIEW_OPTIONS_LABEL': 'Table view options',
  'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_LABEL': 'On-time window',
  'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_HINT': 'Schedule deviation inside this range is colored as on time in the timeline.',
  'TRIP_ANALYZER.QUERY.ON_TIME_LOWER_LABEL': 'Early limit (seconds)',
  'TRIP_ANALYZER.QUERY.ON_TIME_UPPER_LABEL': 'Late limit (seconds)',
  'TRIP_ANALYZER.QUERY.COMPARE_SECTION_LABEL': 'Compare trips',
  'TRIP_ANALYZER.QUERY.COMPARE_SECTION_HINT': 'Compare trips across dates on the same route and direction.',
  'TRIP_ANALYZER.QUERY.COMPARE_TOGGLE_LABEL': 'Compare mode',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_ACTION': 'Add to comparison',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_DISABLED': 'Select a trip to add',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_OPEN_ACTION': 'Add trip',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_DONE_ACTION': 'Done',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_TITLE': 'Add a trip to comparison',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_HINT': 'Change the date, pick a trip, review the preview in the timeline, then add it.',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_CLOSE': 'Close',
  'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_PREVIEW_NOTE': 'A preview row appears in the timeline while this panel is open.',
  'TRIP_ANALYZER.QUERY.COMPARE_SEARCH_SECTION_LABEL': 'Add a trip',
  'TRIP_ANALYZER.QUERY.COMPARE_TRIP_MANAGER_LABEL': 'Comparison set',
  'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_LABEL': 'Filter visible trips',
  'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_HINT': 'Choose which compared trips appear in the table. Hidden trips stay in your comparison set.',
  'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_PLACEHOLDER': 'Select trips to show',
  'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_TRIGGER_SINGULAR': '1 trip',
  'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_TRIGGER_PLURAL': '{count} trips',
  'TRIP_ANALYZER.QUERY.COMPARE_SELECT_PLACEHOLDER': 'No trips in comparison set',
  'TRIP_ANALYZER.QUERY.COMPARE_REMOVE_TRIP_ACTION': 'Remove from comparison',
  'TRIP_ANALYZER.QUERY.COMPARE_PREVIEW_SECTION_LABEL': 'Trip preview',
  'TRIP_ANALYZER.QUERY.COMPARE_PREVIEW_NOTE': 'Preview only — add this trip to include it in the comparison.',
  'TRIP_ANALYZER.QUERY.COMPARE_EDIT_SEARCH_ACTION': 'Change trip or date',
  'TRIP_ANALYZER.QUERY.COMPARE_DONE_SEARCH_ACTION': 'Hide search',
  'TRIP_ANALYZER.QUERY.COMPARE_SEARCH_CONTEXT_LABEL': 'Current search',
  'TRIP_ANALYZER.QUERY.COMPARE_SEARCH_CONTEXT_EMPTY': 'Select date, route, direction, and trip to search',
  'TRIP_ANALYZER.QUERY.COMPARE_ALREADY_IN_SET': 'Already in comparison',
  'TRIP_ANALYZER.QUERY.COMPARE_STAGING_BADGE': 'Preview',
  'TRIP_ANALYZER.QUERY.COMPARE_STAGING_NOTE': 'This trip is not in your comparison yet. Review the row, then add it.',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_CHIPS_LABEL': 'Comparison set',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_COUNT_SINGULAR': 'Comparing 1 trip',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_COUNT_PLURAL': 'Comparing {count} trips',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_CHIPS_HELPER': 'Click × on a chip to remove a trip from the comparison.',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_EMPTY_INLINE': 'No trips added yet. Search below, preview the trip, then add it to the comparison.',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_STEP_CORRIDOR': 'Route & direction',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_STEP_FIRST_TRIP': 'Add first trip',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_STEP_MORE_TRIPS': 'Add more dates',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_START': 'Build a comparison',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_CORRIDOR': 'Choose a route and direction',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_ADD_TRIP': 'Search and add a trip',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_MORE_TRIPS': 'Add trips on other dates',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_START': 'Compare trips across dates on the same route and direction.',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_CORRIDOR': 'Pick the corridor you want to compare. Route and direction stay fixed after your first trip.',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_ADD_TRIP': 'Select a date and trip in Add a trip, review the preview row, then click Add to comparison.',
  'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_MORE_TRIPS': 'Change the date, pick another trip, and add it to grow your comparison.',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_EMPTY_TITLE': 'No trips in comparison set',
  'TRIP_ANALYZER.QUERY.COMPARE_SET_EMPTY_DETAIL': 'Use Add a trip above to search, preview your selection below, then add it here.',
  'TRIP_ANALYZER.QUERY.COMPARE_ALL_HIDDEN_TITLE': 'All comparison trips hidden',
  'TRIP_ANALYZER.QUERY.COMPARE_ALL_HIDDEN_DETAIL': 'Open table controls and use Filter visible trips to show rows again.',
  'TRIP_ANALYZER.QUERY.COMPARE_CORRIDOR_LOCK_TOOLTIP': 'Can only compare trips on the same route and direction',
  'TRIP_ANALYZER.QUERY.COMPARE_SERVICE_DATE_LABEL': 'Compare service date (trip B)',
  'TRIP_ANALYZER.QUERY.COMPARE_TRIP_LABEL': 'Trip B',
  'TRIP_ANALYZER.QUERY.TRIP_A_LABEL': 'Trip A',
};
